import { useEffect, useState } from "react"
import BottomSheet from "./bottomSheet"
import { FlashMessage } from "./flash_message"
import RadioButton from "./radiobutton"
import Stepper from "./stepper"
import Weight from "./weight"
import axios from 'axios';

const Form = () => {
	const [formData, setFormData] = useState({
		gender: undefined,
		height: undefined,
		birthday: undefined,
		weight: undefined
	})
	const [IncalcuteForm, setCalcuteForm] = useState(true)
	const [actionType, setActionType] = useState('calcute')
	const [BMI, setBMI] = useState({})

	const buttonAction = async () => {
		if (IncalcuteForm) {
			await calcuteBMI()
		} else {
			setTimeout(() => {
				setFormData({
					gender: undefined,
					height: undefined,
					birthday: undefined,
					weight: undefined
				})
				setActionType('calcute')
				setCalcuteForm(true)
			}, 300);
		}
	}
	function isEmpty(obj) {
		let array = Object.values(obj)
		let result = array.includes(undefined) || array.includes(null)
		return result
	}
	function getAge(age) {
		let now = new Date()
		let year = now.getFullYear()
		let birthYear = year - age
		return birthYear ? `${birthYear}-01-01` : undefined
	}
	function findEmptyFileds(obj) {
		let result = Object.values(obj), keys = Object.keys(obj), empty = []
		for (let i = 0; i < result.length; i++) {
			if (result[i] === undefined || result[i] === null || result[i] === '') {
				empty.push(keys[i])
			}
		}
		return empty
	}

	// قرار شد اول bmi محاسبه كنم خودم
	// تا زماني كه ميخوام نوع دايت رو به سرور بفرستم خودم تشخيص بدم كاهش وزنه يا افزايش
	// تا موقع دريافت گزارش از سرور ديگه اون ارور رو نشون نده
	const CalculateBMINumber = async (weight, height) => {
		let result = (weight / (Math.pow(height, 2)))
		if (result < 0.0020) {
			return 1
		}
		else if (result > 0.0020 && result <= 0.0025) {
			return 4
		}
		else if (result > 0.0025 && result <= 0.0030) {
			return 2
		}
		else if (result > 0.0030 && result <= 0.0035) {
			return 2
		}
		else if (result > 0.0035 && result <= 0.0040) {
			return 2
		}
		else if (result > 0.0040) {
			return 2
		}
	}

	// محاسبه bmi
	const calcuteBMI = async () => {
		let a = await CalculateBMINumber(formData.weight, formData.height)
		let viewModel = {
			diet_type_id: a,
			gender: formData.gender,
			birthday: getAge(formData.birthday),
			weight: formData.weight ? formData.weight * 1000 : undefined,
			height: formData.height,
			wrist: 16,
		}
		let Empty = isEmpty(viewModel)
		if (!Empty) {
			scrollTop()
			if (viewModel.height < 130 || viewModel.height > 250) {
				FlashMessage('error', 'يجب أن يكون الارتفاع بين 130 و 250')
			} else if (formData.birthday < 13 || formData.birthday > 75) {
				FlashMessage('error', 'يجب أن يكون العمر بين 13 و 75 سنة')
			} else {
				try {
					let data;
					await axios.get(`https://diet2.gosnalban.com/back/public/api/physicalConditions?diet_type_id=${viewModel.diet_type_id}&gender=${viewModel.gender}&birthday=${viewModel.birthday}&weight=${viewModel.weight}&height=${viewModel.height}&wrist=${viewModel.wrist}`)
						.then(response => {
							data = response.data.data
						})
					setBMI(data)
					setActionType('reset')
					setCalcuteForm(false)
				} catch (error) {
					console.error(error)
				}
			}
		} else {
			let emptyFileds = findEmptyFileds(viewModel)
			if (emptyFileds.length > 0) {
				for (let i = 0; i < emptyFileds.length; i++) {
					if (emptyFileds[i] === 'height') {
						FlashMessage('error', 'يرجى إدخال الطول')
					} else if (emptyFileds[i] === 'weight') {
						FlashMessage('error', 'یرجى إدخال الوزن')
					} else if (emptyFileds[i] === 'birthday') {
						FlashMessage('error', 'يرجى إدخال العمر')
					} else if (emptyFileds[i] === 'gender') {
						FlashMessage('error', 'يرجى إدخال الجنس')
					} else { }
				}
			}
		}
	}

	const scrollTop = async () => {
		setTimeout(() => {
			const section = document.getElementById('top');
			section.scrollIntoView({ behavior: 'smooth', block: 'start', });
		}, 200);
	}

	return <>
		<div className={`content ${!IncalcuteForm ? 'hide' : ''}`}>
			<p className='description'>من المهم أن تدخل هذه المعلومات بشكل دقيق<br />
				حتى تتمكن من معرفـة وزنك المثــالي الحقيقي</p>
			<div className={`${!IncalcuteForm ? 'hide' : ''}`}>
				<div className="display_flex justify_content_between">
					<RadioButton
						value={0}
						selected={formData.gender === 0}
						onChange={() => setFormData({ ...formData, gender: 0 })}
						id={'gender0'}
						name={'gender'}
						checked={formData.gender === 0}
					/>
					<RadioButton
						value={1}
						selected={formData.gender === 1}
						onChange={() => setFormData({ ...formData, gender: 1 })}
						id={'gender1'}
						name={'gender'}
						checked={formData.gender === 1}
					/>
				</div>
				<Weight
					change={(val) => setFormData({ ...formData, weight: val })}
					value={formData.weight} />
				<div className="display_flex justify_content_between">
					<Stepper
						title="العمر"
						unit="سنة"
						min={13}
						max={75}
						placeholder={24}
						value={formData.birthday || ''}
						change={(val) => setFormData({ ...formData, birthday: val })}
					/>
					<Stepper
						title="الطول"
						unit="سنتيمتر"
						min={130}
						max={250}
						placeholder={168}
						value={formData.height || ''}
						change={(val) => setFormData({ ...formData, height: val })}
					/>
				</div>
			</div>
		</div>



		<BottomSheet
			action={() => buttonAction()}
			actionType={actionType}
			data={BMI}
		/>
	</>
}
export default Form